import { selectHasShownMultipackMessageFor } from './toastsSelectors';
import { actionSetHasShownMultipackMessageFor } from './toastsActions';
import { Thunk } from '../../generalTypes';
import { isOnlyAvailableInMultipack } from '../../services/products';
import { showMultipackToast } from '../../services/toastMaster';
import constants from '../../settings/constants';

export const thunkShowMultipackMessageIfNeededFor: Thunk<any> =
  (itemId: string) => (dispatch, getState) => {
    if (!isOnlyAvailableInMultipack(itemId)) return;

    const idsOfItemsAlreadyShownFor = selectHasShownMultipackMessageFor(
      getState()
    );
    if (idsOfItemsAlreadyShownFor.includes(itemId)) return;

    dispatch(
      actionSetHasShownMultipackMessageFor([
        ...idsOfItemsAlreadyShownFor,
        itemId,
      ])
    );

    /* TODO: It would be nice nice to do some refactoring, so that we don't just call
     functions in toastMaster when we want to show/queue toasts. The solution should
     probably be based on state, similarly to how we handle popups and sheets. */
    showMultipackToast(constants.BULK_ARTICLES[itemId].bulkSize);
  };
